module.exports = __webpack_public_path__ + "img/_54A2259.c8986f8b.jpg";